import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { platformApiFetch } from '../../api/client';

export const SETTINGS_QUERY_KEY = ['platform', 'settings'];
export const SETTINGS_HISTORY_QUERY_KEY = ['platform', 'settings', 'history'];

export function usePlatformSettings() {
  return useQuery({
    queryKey: SETTINGS_QUERY_KEY,
    queryFn: () => platformApiFetch('/api/platform/settings'),
  });
}

export function usePlatformSettingsHistory() {
  return useQuery({
    queryKey: SETTINGS_HISTORY_QUERY_KEY,
    queryFn: () => platformApiFetch('/api/platform/settings/history'),
  });
}

export function usePlatformSettingsVersion(hash, { enabled = true } = {}) {
  return useQuery({
    queryKey: ['platform', 'settings', 'versions', hash],
    queryFn: () => platformApiFetch(`/api/platform/settings/versions/${hash}`),
    enabled: Boolean(hash) && enabled,
  });
}

export function useUpdatePlatformSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      platformApiFetch('/api/platform/settings', {
        method: 'PATCH',
        body,
        errorMessage: 'Failed to update settings',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SETTINGS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: SETTINGS_HISTORY_QUERY_KEY });
    },
  });
}

export function useRestorePlatformSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      platformApiFetch('/api/platform/settings/restore', {
        method: 'POST',
        body,
        errorMessage: 'Failed to restore settings',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SETTINGS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: SETTINGS_HISTORY_QUERY_KEY });
    },
  });
}
